<template>
  <div>
    <div v-if="!passward" class="captcha">
        <div class="text-center">
        <h2 class="text-2xl font-bold mb-8 text-gray-700" style="text-align: center;">请输入4位密码</h2>
        
        <div class="password-container">
            <input type="text" maxlength="1" class="password-input" data-index="0" autofocus>
            <input type="text" maxlength="1" class="password-input" data-index="1">
            <input type="text" maxlength="1" class="password-input" data-index="2">
            <input type="text" maxlength="1" class="password-input" data-index="3">
        </div>
        <div class="message" id="message"></div>
        </div>
    </div>
    <div class="container" v-else>
      <div class="card">
        <div class="card-header">
          <div class="card-title">设备信息</div>
          <div class="card-status">
            <div v-if="valveDatas.status === 100" class="status-common status-open">
              <div class="dian open"></div>
              运行中
            </div>
            <div v-if="valveDatas.status === 0" class="status-common status-off">
              <div class="dian off"></div>
              已关闭
            </div>
          </div>
        </div>
        <div class=card-columns>
          <div class=column>
            <i class="iconfont icon-dingwei" style="color: #3b82f6;"></i>
            <div class="column-right">
              <div class="location-label">安装位置</div>
              <div class="location-value">{{ valveDatas.userAdd }}</div>
            </div>
          </div>
          <div class=column>
            <i class="iconfont icon-shebei1" style="color: #a855f7;"></i>
            <div class="column-right">
              <div class="location-label">设备号</div>
              <div class="location-value">{{ valveDatas.imei }}</div>
            </div>
          </div>
          <div class=column>
            <i class="iconfont icon-shebei1" style="color: #a855f7;"></i>
            <div class="column-right">
              <div class="location-label">口径</div>
              <div class="location-value">{{ valveDatas.caliber }}</div>
            </div>
          </div>
        </div>
        <div class="time" style="display: none;">
          <i class="iconfont icon-shijian"></i>
          <span>最后更新：2025/08/25 14:22:02</span>
        </div>
      </div>
      <div class="card" style="padding-bottom: 0;">
        <div class="card-header">
          <div class="card-title">
            <i class="iconfont icon-kaiguan" style="color: #f59e0b;"></i>
            阀门控制
            </div>
        </div>
        <div class="valve-container">
          <div class="valve-icons">
            <div class="valve-bg" :class="valveDatas.status === 100 ? 'success' : ''">
              <i class="iconfont icon-famen" :class="valveDatas.status === 100 ? 'famen-status' : ''"></i>
            </div>
          </div>
          <div class="tips">阀门当前处于<span>{{ valveDatas.status === 0 ? '关闭' : '开启' }}</span>状态</div>
          <div class="valve-btns" :class="valveDatas.status === 100 ? 'off' : ''" @click="handleSwitch(valveDatas.status)">
            <i class="iconfont" :class="valveDatas.status === 100 ? 'icon-zanting' : 'icon-kaiguan'"></i>
            <div class="btn-words">{{ valveDatas.status === 100 ? '关闭阀门' : '开启阀门' }}</div>
          </div>
          <!-- <div v-if="valveDatas.status === 1" class="valve-btns off" @click="handleSwitch(1)">
            <i class="iconfont icon-kaiguan" style="color: #ffffff; font-size: 15px; margin-right: 5px"></i>
            <div class="btn-words">开启阀门</div>
          </div> -->
        </div>
      </div>
      <div class="loading" v-if="valveOpen">
        <i class="iconfont icon-jiazai"></i>
        <span>处理中</span>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
    data() {
      return {
        passward: '',
        valveOpen: false,
        valveDatas: {},
        params: {
          deviceid: "",
          operate: 1
        }
      }
    },
    created() {
      this.init();
      this.getValve();
    },
    methods: {
      init() {
      document.addEventListener('DOMContentLoaded', () => {
        const inputs = document.querySelectorAll('.password-input');
        const message = document.getElementById('message');
        const correctPassword = '0666';
        
        inputs.forEach((input, index) => {
            // 处理输入
            input.addEventListener('input', function(e) {
                if (this.value.length === 1) {
                    if (index < inputs.length - 1) {
                        inputs[index + 1].focus();
                    } else {
                        // 最后一个输入框输入完成，验证密码
                        verifyPassword();
                    }
                }
            });
            
            // 处理删除键
            input.addEventListener('keydown', function(e) {
                if (e.key === 'Backspace' && this.value.length === 0 && index > 0) {
                    inputs[index - 1].focus();
                }
            });
        });
        
        const verifyPassword = () => {
            let enteredPassword = '';
            inputs.forEach(input => {
                enteredPassword += input.value;
            });
            
            message.classList.remove('success', 'error');
            
            if (enteredPassword === correctPassword) {
                message.textContent = '密码正确';
                message.classList.add('success');
                setTimeout(() => {
                    this.passward = true;
                }, 1000)
            } else {
                message.textContent = '密码错误，请重试';
                message.classList.add('error');
                
                // 清空输入框并聚焦第一个
                inputs.forEach(input => input.value = '');
                inputs[0].focus();
            }
          }
       });
      },
      getValve() {
        const id = this.$route.query.id;
        axios.get('/api1/app/valve/info/' + id).then(res=>{
          if(res.data.code === 200){
            this.valveDatas = res.data.data
            // this.value = res.data.data.status === 1 ? false : true
            this.params.deviceid = res.data.data.deviceId
          }
        })
      },
      handleSwitch(e) {
        this.params.operate = e === 100 ? 0 : 100;
        const loading = this.$loading({
          lock: true,
          text: '处理中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        axios.post('/api1/app/valve/operatefm',this.params).then(res=>{
          if(res.data.code === 200){
            this.$notify({
              title: '成功',
              message: '操作成功',
              type: 'success'
            });
            this.getValve();
            loading.close();
          }
        })
      }
    }
}
</script>

<style scoped>
/* 公共样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}
.iconfont {
  font-size: 20px;
}
.container {
  /* width: 100vw; */
  /* min-height: 100vh; */
  background: #f4f7fa;
  overflow: hidden;
  position: relative;
}

.card {
  max-width: 800px;
  margin: 20px auto 0;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  margin-bottom: 30px;
  overflow: hidden;
  padding: 1.5rem;
  box-sizing: border-box;
}

.card-header {
  padding: 16px 20px;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.card-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}
.card-status .status-common {
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 12px;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.status-open {
  background: #dcfce7;
  color: #166534;
}
.status-off {
  background: #fee2e2;
  color: #991b1b;
}
.dian {
  width: 15px;
  height: 15px;
  border-radius: 50%;
  margin-right: 5px;
}
.status-common .open {
  background: #166534;
}
.status-common .off {
  background: #991b1b;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.card-columns {
  padding: 20px;
  box-sizing:  border-box;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
}
.column {
  width: 48%;
  padding: 0.75rem;
  border-radius: 0.75rem;
  background: #f8fafc;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
@media screen and (min-width: 633px) and (max-width: 890px) {
  .card {
    max-width: 550px;
  }
}
@media screen and (max-width: 630px) {
  .column {
    width: 100%;
    margin-bottom: 20px;
  }
  .card {
    max-width: 300px;
  }
}
.column .iconfont {
  font-size: 18px;
  margin-right: 10px
}
.column-right .location-label {
  font-size: 0.875rem;
  line-height: 1.25rem;
  color: #999999;
}
.column-right .location-value {
  font-size: 0.875rem;
  font-weight: 500;
}
.time {
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #999999;
}
.icon-shijian {
  margin-right: 5px;
  font-size: 15px;
}
.valve-container {
  padding: 20px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.valve-icons {
  width: 160px;
  height: 160px;
  border-radius: 50%;
  border: 8px solid #e2e8f0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.valve-bg {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: #fee2e2;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon-famen {
  color: #dc2626;
  font-size: 40px;
  animation: rotate-90-cw 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}
.famen-status {
  color: #16a34a;
  animation: rotate-90-cw1 0.4s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}
@-webkit-keyframes rotate-90-cw {
  0% {
    -webkit-transform: rotate(90deg);
            transform: rotate(90deg);
  }
  100% {
    -webkit-transform: rotate(0);
            transform: rotate(0);
  }
}
@-webkit-keyframes rotate-90-cw1 {
  0% {
    -webkit-transform: rotate(0);
            transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(90deg);
            transform: rotate(90deg);
  }
}
.tips {
  font-size: 20px;
  font-weight: 600;
  margin: 15px 0;
}
.tips span {
  color: #dc2626;
  margin: 0 5px;
}
.valve-btns {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 20px;
  border-radius: 40px;
  box-shadow: 0 0 #000;
  background: #16a34a;
  color: #ffffff;
  font-size: 14px;
}
.off {
  background: #b91c1c;
}
.success {
  background: #dcfce7;
}
.icon-zanting {
  margin-right: 5px;
  font-size: 16px;
}
.valve-btns :hover {
  cursor: pointer;
}
.loading {
  position: absolute;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 14px;
}
.icon-jiazai {
  font-size: 28px;
  margin-bottom: 10px;
  animation: rotate-360 1s linear infinite both;
}
@-webkit-keyframes rotate-360 {
  0% {
    -webkit-transform: rotate(0);
            transform: rotate(0);
  }
  100% {
    -webkit-transform: rotate(360deg);
            transform: rotate(360deg);
  }
}
.captcha {
    width: 100%;
    height: 90vh;
    display: flex;
    justify-content: center;
    align-items: center;
}
.password-container {
    display: flex;
    gap: 10px;
    margin: 20px;
}

.password-input {
    width: 50px;
    height: 50px;
    border: 2px solid #ccc;
    border-radius: 4px;
    text-align: center;
    font-size: 24px;
    transition: all 0.3s ease;
}

.password-input:focus {
    border-color: #4285f4;
    transform: scale(1.05);
    outline: none;
    box-shadow: 0 0 5px rgba(66, 133, 244, 0.3);
}

.message {
    text-align: center;
    font-size: 18px;
    font-weight: 500;
    opacity: 0;
    transition: opacity 0.5s ease;
}

.success {
    color: #34a853;
    opacity: 1;
}

.error {
    color: #ea4335;
    opacity: 1;
}
</style>


// WEBPACK FOOTER //
// src/components/valveControl.vue